'use strict';

exports.__esModule = true;
exports.localize = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _locale = require('../modules/locale');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localize = exports.localize = function localize(localeKey) {
  return function (Component) {

    var Localize = function Localize(props) {
      return _react2.default.createElement(Component, props);
    };

    var mapStateToProps = function mapStateToProps(state) {
      var translations = (0, _locale.getTranslationsForKey)(localeKey)(state);
      return {
        currentLanugage: state.locale.currentLanguage,
        translate: function translate(key, data) {
          return (0, _utils.getLocalizedElement)(key, translations, data);
        }
      };
    };

    // use cases
    // I have ${ variable } and another ${ variable }

    return (0, _reactRedux.connect)(mapStateToProps, null)(Localize);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-localize-redux/lib/containers/Localize.js
// module id = 212
// module chunks = 0